type Props = {
  token: string;
  application: string;
  version: string;
};

export function HorizonTrackJsScript({ token, application, version }: Props) {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
(function() {
  window._trackJs = {
    token: "${token}",
    enabled: true,
    application: "${application}",
    version: "${version}",
    network: {
      enabled: true,
      // Stop automatically tracking 400 or greater network errors
      error: false
    },
    onError: function(payload, error) {
      if (
        payload.environment.userAgent.indexOf('SamsungBrowser/7.2') !== -1 &&
        error.message === 'document.getElementsByClassName.ToString is not a function'
      ) {
        // Ignore misbehaving browser
        // See: https://github.com/SamsungInternet/support/issues/56#issuecomment-402423676
        return false
      }

      if (
        error.message === 'window.dor.by is not a function' &&
        payload.environment.userAgent.indexOf('Android') !== -1 &&
        payload.environment.userAgent.indexOf('Chrome/') !== -1
      ) {
        return false
      }

      payload.console.push({
        severity: 'log',
        timestamp: new Date().toISOString(),
        message: window._trackJs.user
      });

      payload.console.push({
        severity: 'log',
        timestamp: new Date().toISOString(),
        message: document.cookie
      });

      return true;
    }
  };

  window.Idealist.beforeTrackJsErrors = []
  window.Idealist.trackErrorBeforeTrackJs = function(event) {
    window.Idealist.beforeTrackJsErrors.push(event.error)
  }

  window.addEventListener('error', window.Idealist.trackErrorBeforeTrackJs)
})();
      `,
      }}
    />
  );
}
